export default {
  meta: {
    title: '设备管理'
  }
};
